{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Pobierz",
      "UPLOADING": "Przesyłanie..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Wyślij"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Wyślij wiadomość ponownie",
      "ERROR_MESSAGE": "Nie udało się wysłać! Spróbuj ponownie"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Not available"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Jesteśmy dostępni",
    "OFFLINE": "W tej chwili jesteśmy niedostępni",
    "BACK_AS_SOON_AS_POSSIBLE": "Wrócimy tak szybko, jak to możliwe"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Zwykle odpowiadamy w ciągu paru minut",
    "IN_A_FEW_HOURS": "Zwykle odpowiadamy w ciągu paru godzin",
    "IN_A_DAY": "Zwykle odpowiadamy w przeciągu jednego dnia",
    "BACK_IN_HOURS": "Będziemy ponownie dostępni za {n} godzinę | Będziemy ponownie dostępni za {n} godzin",
    "BACK_IN_MINUTES": "Będziemy ponownie dostępni za {time} minut",
    "BACK_AT_TIME": "Będziemy ponownie dostępni o {time}",
    "BACK_ON_DAY": "Będziemy ponownie dostępni w {day}",
    "BACK_TOMORROW": "Będziemy ponownie dostępni jutro",
    "BACK_IN_SOME_TIME": "Będziemy ponownie dostępni niedługo"
  },
  "DAY_NAMES": {
    "SUNDAY": "Niedziela",
    "MONDAY": "Poniedziałek",
    "TUESDAY": "Wtorek",
    "WEDNESDAY": "Środa",
    "THURSDAY": "Czwartek",
    "FRIDAY": "Piątek",
    "SATURDAY": "Sobota"
  },
  "START_CONVERSATION": "Rozpocznij rozmowę",
  "END_CONVERSATION": "Zakończ rozmowę",
  "CONTINUE_CONVERSATION": "Kontynuuj rozmowę",
  "YOU": "You",
  "START_NEW_CONVERSATION": "Rozpocznij nową rozmowę",
  "VIEW_UNREAD_MESSAGES": "You have unread messages",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Pokaż nowe wiadomości",
    "CLOSE_MESSAGES_BUTTON": "Zamknij",
    "COMPANY_FROM": "od",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Porozmawiaj z nami"
  },
  "POWERED_BY": "Napędzany przez Chatwoot",
  "EMAIL_PLACEHOLDER": "Wprowadź swój adres e-mail",
  "CHAT_PLACEHOLDER": "Wpisz treść wiadomości",
  "TODAY": "Dzisiaj",
  "YESTERDAY": "Wczoraj",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Pełna nazwa (imię i nazwisko)",
        "PLACEHOLDER": "Podaj swoje imię i nazwisko",
        "REQUIRED_ERROR": "Pełne imię i nazwisko jest wymagane"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Adres e-mail",
        "PLACEHOLDER": "Wprowadź swój adres e-mail",
        "REQUIRED_ERROR": "Adres email jest wymagany",
        "VALID_ERROR": "Wprowadź poprawny adres e-mail"
      },
      "PHONE_NUMBER": {
        "LABEL": "Numer telefonu",
        "PLACEHOLDER": "Wprowadź numer telefonu",
        "REQUIRED_ERROR": "Numer telefonu jest wymagany",
        "DIAL_CODE_VALID_ERROR": "Proszę wybrać kod kraju",
        "VALID_ERROR": "Wprowadź poprawny numer telefonu",
        "DROPDOWN_EMPTY": "Brak wyników",
        "DROPDOWN_SEARCH": "Search country"
      },
      "MESSAGE": {
        "LABEL": "Wiadomość",
        "PLACEHOLDER": "Wprowadź swoją wiadomość",
        "ERROR": "Wiadomość jest za krótka"
      }
    },
    "CAMPAIGN_HEADER": "Proszę podać swoje imię i nazwisko oraz adres e-mail przed rozpoczęciem rozmowy",
    "IS_REQUIRED": "jest wymagane",
    "REQUIRED": "Wymagane",
    "REGEX_ERROR": "Please provide a valid input"
  },
  "FILE_SIZE_LIMIT": "Plik przekracza limit {MAXIMUM_FILE_UPLOAD_SIZE} dla załącznika",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Nieprawidłowe pole"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Wyszukaj emoji",
    "NOT_FOUND": "Nie znaleziono emoji pasującego do wyszukiwania",
    "ARIA_LABEL": "Emoji picker"
  },
  "EMOJI_ICON_PICKER": {
    "SEARCH_EMOJI": "Search emoji…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Nie znaleziono emoji pasującego do wyszukiwania"
  },
  "CSAT": {
    "TITLE": "Oceń udzielone Ci wsparcie",
    "SUBMITTED_TITLE": "Dziękujemy za przesłanie oceny",
    "PLACEHOLDER": "Dodaj swój komentarz..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Poproś o skrypt rozmowy",
    "SEND_EMAIL_SUCCESS": "Transkrypcja czatu została wysłana pomyślnie",
    "SEND_EMAIL_ERROR": "Wystąpił błąd, spróbuj ponownie"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Kliknij tutaj, aby dołączyć",
      "LEAVE_THE_ROOM": "Opuść rozmowę"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popular Articles",
    "VIEW_ALL_ARTICLES": "Zobacz wszystkie artykuły",
    "IFRAME_LOAD_ERROR": "There was an error loading the article, please refresh the page and try again."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Wiadomość z obrazkiem"
    },
    "audio": {
      "CONTENT": "Wiadomość dźwiękowa"
    },
    "video": {
      "CONTENT": "Wiadomość wideo"
    },
    "file": {
      "CONTENT": "Załącznik pliku"
    },
    "location": {
      "CONTENT": "Lokalizacja"
    },
    "fallback": {
      "CONTENT": "udostępnił adres URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Replying to:"
  }
}
